import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Logo from '../../../Components/common/Logo/Logo';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import "./Navbar.css";

export default function Navbar({ title, userInfo, onRefresh, onLogout, onMenuToggle }) {
  const { t } = useTranslation(['common', 'admin']);
  const [open, setOpen] = useState(false);

  // ─── MODE ADMIN (quand title ou userInfo est fourni) ───────────────────────
  if (title || userInfo) {
    return (
      <div className="admin-topbar">
        <div className="admin-topbar-left">
          {onMenuToggle && (
            <button
              className="admin-topbar-hamburger"
              onClick={onMenuToggle}
              aria-label={t('admin:topbar.openMenu')}
              title={t('ui.menu')}
            >
              ☰
            </button>
          )}
          <Logo variant="full" theme="light" size="sm" className="admin-topbar-logo" />
          <h2 className="admin-topbar-title">{title || t('admin:topbar.dashboard')}</h2>
        </div>
        <div className="admin-topbar-right">
          <LanguageSwitcher variant="pills" />
          <ThemeToggle />
          {onRefresh && (
            <button className="admin-topbar-refresh" onClick={onRefresh} title={t('admin:topbar.refresh')}>
              {t('admin:topbar.refresh')}
            </button>
          )}
          {userInfo && (
            <div className="admin-topbar-user">
              <div className="admin-topbar-avatar">
                {(userInfo.name || "A")[0].toUpperCase()}
              </div>
              <div className="admin-topbar-info">
                <span className="admin-topbar-name">{userInfo.name || t('admin:topbar.administrator')}</span>
                <span className="admin-topbar-role">{userInfo.role || t('admin:topbar.admin')}</span>
              </div>
            </div>
          )}
          {onLogout && (
            <button
              className="admin-topbar-logout"
              onClick={onLogout}
              title={t('admin:topbar.logout')}
              aria-label={t('admin:topbar.logout')}
            >
              {t('admin:topbar.logout')}
            </button>
          )}
        </div>
      </div>
    );
  }

  // ─── MODE PUBLIC (navigation standard) ────────────────────────────────────
  const toggleMenu = () => setOpen(!open);
  const closeMenu = () => setOpen(false);

  return (
    <header className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu} aria-label={t('ui.homeAria')}>
          <Logo variant="full" theme="dark" height={44} />
        </Link>

        <button className="nav-toggle" onClick={toggleMenu} aria-label={t('common:nav.home')}>
          ☰
        </button>

        <nav className={`nav-menu ${open ? "open" : ""}`}>
          <Link to="/" onClick={closeMenu}>{t('common:nav.home')}</Link>
          <Link to="/travels" onClick={closeMenu}>{t('common:nav.trips')}</Link>
          <Link to="/about" onClick={closeMenu}>{t('common:nav.about')}</Link>
          <Link to="/contact" onClick={closeMenu}>{t('common:nav.contact')}</Link>
          <Link to="/login" onClick={closeMenu}>{t('common:nav.login')}</Link>
          <Link to="/signup" onClick={closeMenu}>{t('common:nav.signup')}</Link>
        </nav>
      </div>
    </header>
  );
}
